<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CButton @click="collapse=!collapse" color="primary" class="mb-2">
                    فیلتر داده‌ها
                </CButton>
                <CCollapse :show="collapse" :duration="400">
                    <CCard>
                        <CCardHeader>
                            <strong>گزینه‌های فیلتر</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.from_number.val" size="sm" dir="ltr" disabled />
                                    <CButton @click="modal=true" size="sm" color="info" block>انتخاب شماره</CButton>
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.to_num.val" :description="form.to_num.inv" dir="ltr" label="به شماره" />
                                </CCol>
                                <CCol sm="3">
                                    <label>از تاریخ</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.created_at.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.created_at.inv}}</small>
                                </CCol>
                            </CRow>
                            <CRow> 
                                <CCol sm="3">
                                    <label>تا تاریخ</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.created_at_until.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.created_at_until.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.state.val"
                                        :description="form.state.inv"
                                        label="وضعیت"
                                        :options="[
                                            {value: '', label: 'هیچ‌کدام'},
                                            {value: '1', label:'تحویل داده شده'},
                                            {value: '2', label:'تحویل داده نشده'},
                                            {value: '3', label:'ارسال شده به مخابرات'},
                                            {value: '-1', label:'لیست سیاه'},
                                            {value: '-2', label:'تایید نشده'},
                                            {value: '-3', label:'خطا در ارسال'},
                                            {value: '-4', label:'ارسال شده و در انتظار تعیین وضعیت'},
                                            {value: '-5', label: 'ارسال نشده'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.state.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.message_uuid.val" :description="form.message_uuid.inv" dir="ltr" label="UUID" />
                                </CCol>
                                <CCol sm="3" v-show="$store.state.perms.can_request_gateway_info">
                                    <label>درگاه</label>
                                    <model-select :options="gateways" v-model="form.gateway_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.gateway_id.inv}}</small>
                                </CCol>
                            </CRow>
                            <br>
                            <div class="form-group form-actions">
                                <CButton @click="validator();filter=true;page=1;get();" class="ml" color="primary">فیلتر</CButton>
                                <CButton @click="remove_filter" class="ml" color="danger">حذف فیلتر</CButton>
                                <CButton @click="download_modal=true" v-show="$store.state.perms.can_user_download_message_in_csv_format"
                                    color="primary">دانلود گزارش با فرمت CSV</CButton>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCollapse>
            </CCol>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>گزارش ارسال پیام صوتی</strong>
                        <div class="card-header-actions">
                            تعداد: {{row_count}}
                        </div>
                        <br>
                        <small>گزارش‌هایی که از تاریخ ایجاد آن‌ها یک هفته گذشته است را در صفحه‌ گزارش آرشیو مشاهده کنید.</small>
                    </CCardHeader>
                    <CCardBody>
                        <CCol sm="5">
                            <CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
                                {value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count" placeholder="تعداد سطرها" @change="limit=$event.target.value" />
                        </CCol>
                        <CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                            <template #user_name="data">
                                <td>
                                    <router-link :to="`/profile/${data.item.user_id}`">{{data.item.user_name}}</router-link>
                                </td>
                            </template>
                            <template #sms_text="data">
                                <td><CButton color="link">{{data.item.sms_text}}</CButton> </td>
                            </template>
                            <template #state="data">
                                <td>
                                    <CBadge :color="get_badge(data.item.state)">
                                        {{data.item.state}}
                                    </CBadge>
                                </td>
                            </template>
                            <template #action="data">
                            <td>
                                <template>
                                <div class="flex-container">
                                    <div @click="redirect_to(`/message/${data.item.uuid}/send`)"
                                        v-c-tooltip.hover="'جزییات'">
                                        <CIcon name="cilListRich" size="lg"/>
                                    </div>
                                </div>
                                </template>
                            </td>
                            </template>
                        </CDataTable>
                            <br>
                            <div> 
                                <CPagination
                                :activePage.sync="page"
                                :pages="page_count"
                                align="center"
                                :doubleArrows="true"
                                />
                            </div>
                        </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
            title="دقت کنید"
            size="sm"
            color="primary"
            :show.sync="download_modal"
            >
            <p>آیا برای دانلود گزارش با فرمت CSV اطمینان دارید؟</p>
            <template #footer>
                <CButton @click="download_modal=false" color="secondary">خیر</CButton>
            <CButton @click="validator();download()" color="primary">بله</CButton>
            </template>
        </CModal>
        <CModal
            title="انتخاب شماره"
            size="sm"
            color="info"
            :show.sync="modal"
            >
            <CRow>
                <CCol sm="12">
                    <CInput v-model="number_like" @keyup.enter="get_numbers()" dir="ltr" label="جستجو در شماره‌ها"/>
                    <small>راهنما: برای جستجو در شماره‌ها چند رقم از شماره مورد نظر را وارد کرده و سپس دکمه Enter را فشار دهید. پس از نمایش پیغام پایان جستجو، شماره مورد نظر را از زیر انتخاب کنید.</small>
                </CCol>
                <CCol sm="12">
                    <br/>
                    <label>انتخاب شماره</label>
                    <model-select :options="numbers" v-model="from_selected" placeholder="انتخاب کنید">
                    </model-select>
                    <small class="form-text text-muted w-100">{{form.from_number.inv}}</small>
                </CCol>
            </CRow>
            <template #footer>
                <CButton @click="form.from_number.val=from_selected;modal=false;" color="primary">تایید</CButton>
                <CButton @click="modal=false" color="secondary">بستن</CButton>
            </template>
        </CModal>
    </div>
</template>
<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data () {
        return {
            row_count: '',
            items: [],
            fields: [
                { key: 'user_name', label: 'کاربر' },
                { key: 'out_box_sms_groups.from_number', label: 'از شماره' },
                { key: 'out_box_sms_messages.to_num', label: 'به شماره' },
                { key: 'sms_text', label: 'پیام' },
                { key: 'created_at', label: 'تاریخ ایجاد' },
                { key: 'send_at', label: 'تاریخ ارسال' },
                { key: 'state', label: 'وضعیت' },
                { key: 'action', label: 'عملیات' },
            ],
            collapse: false,
            form: {
                user_id: { val: '', inv: '', v: { max: 8 } },
                from_number: { val: '', inv: '', v: { max: 16 } },
                to_num: { val: '', inv: '', v: { max: 16 } },
                created_at: { val: '', inv: '', v: { max: 16 } },
                created_at_until: { val: '', inv: '', v: { max: 16 } },
                state: { val: '', inv: '', v: { max: 4 } },
                message_uuid: { val: '', inv: '', v: { max: 64 } },
                gateway_id: { val: '', inv: '', v: { max: 8 } },
            },
            filter: false,
            disable: false,
            page: 1,
            page_count: 0,
            offset: 0,
            limit: 10,
            download_modal: false,
            users: [],
            gateways: [],
            modal: false,
            number_like: '',
            numbers: [],
            from_selected: '',
        }
    },
    watch: {
        page: {
            handler(){
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        limit: {
            handler() {
                this.page = 1;
                this.get();
            }
        },
    },
    mounted(){
        this.get();
        this.get_users();
        if(this.$store.state.perms.can_request_gateway_info){
            this.get_gateways();
        }
    },
    methods: {
        get_numbers() {
            this.axios.get('user_nums/'
                + '?number_like=' + this.number_like)
                .then(res => {
                    res.data.map(val => {
                        this.numbers.push({ value: `${val.number}`, text: `${val.number}`});
                    });
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        text: 'جستجوی شماره‌ها با موفقیت انجام شد.'
                    });
                })
        },
        get_gateways(){
            this.axios.get('sms_gateways/')
            .then(res => {
                res.data.map(val => {
                    this.gateways.push({value: val.id, text: val.name});
                });
            })
        },
        get_users(){
            this.axios.get('users/?type=view_sms_messages')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
        get_badge(status) {
            switch(status) {
                case 'لیست سیاه': return 'danger';
                case 'رد شده': return 'danger';
                case 'در صف ارسال': return 'warning';
                case 'ارسال شده و در انتظار تعیین وضعیت': return 'info';
                case 'تحویل داده نشده': return 'danger';
                case 'تحویل داده شده': return 'success';
                case 'تایید نشده': return 'warning';
                case 'خطا در ارسال': return 'danger';
                case 'ارسال شده به مخابرات': return 'info';
            }
        },
        open_to(route) {
            window.open(`/#${route}`, '_blank').focus()
        },
        download(){
            this.$notify({
                group: 'foo',
                type: 'success',
                text: 'فایل در حال دانلود است. لطفا صبور باشید.'
            });
            this.download_modal = false;
            if(this.disable == false){
                let filter = '';
                for (const key in this.form) {
                    if(this.form[key].val != ''){
                        if (key == 'created_at') {
                            filter += `&out_box_sms_messages.${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                        } else if(key == 'created_at_until'){
                            if(this.form[key].val != ''){
                                filter += `&${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                            }
                        } else if(key == 'user_id' || key == 'from_number' || key == 'sms_tex'){
                            filter += `&out_box_sms_groups.${key}=` + this.form[key].val;
                        } else if(key == 'to_num' || key == 'state' || key == 'message_uuid'){
                            filter += `&out_box_sms_messages.${key}=` + this.form[key].val;
                        } else if(key == 'gateway_id'){
                            filter += `&${key}=` + this.form[key].val;
                        }
                    }
                }
                filter += '&message_type=voice';
                this.axios.get('sms_messages/' 
                    + '?download=1' 
                    + filter, {responseType: 'blob'})
                    .then(res => {
                        const FileSaver = require('file-saver');
                        FileSaver.saveAs(new Blob([res.data], {type : res.headers['content-type']}));
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        },
        get() {
            if (this.disable == false) {
                let filter = '';
                if(this.filter){
                    for (const key in this.form) {
                        if(this.form[key].val != ''){
                            if (key == 'created_at') {
                                filter += `&out_box_sms_messages.${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                            } else if(key == 'created_at_until'){
                                if(this.form[key].val != ''){
                                    filter += `&${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                                }
                            } else if(key == 'user_id' || key == 'from_number' || key == 'sms_tex'){
                                filter += `&out_box_sms_groups.${key}=` + this.form[key].val;
                            } else if(key == 'to_num' || key == 'state' || key == 'message_uuid'){
                                filter += `&out_box_sms_messages.${key}=` + this.form[key].val;
                            } else if(key == 'gateway_id'){
                                filter += `&${key}=` + this.form[key].val;
                            }
                        }
                    }
                }
                this.axios.get('sms_messages/' 
                    + '?count=1'  
                    + '&message_type=voice' 
                    + filter)
                    .then(res => {
                        this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
                        this.offset = 0;
                        if(this.page != 1){
                            this.offset = (this.page * this.limit) - this.limit;
                        }
                    })
                .finally(() => {
                    this.axios.get('sms_messages/' 
                        + '?limit=' + this.limit 
                        + '&offset=' + this.offset 
                        + '&message_type=voice' 
                        + '&user_info=1' 
                        + filter)
                        .then(res => {
                            res.data.map(val =>{
                                val.uuid = val['out_box_sms_messages.message_uuid'];
                                val.user_id = val['out_box_sms_groups.user_id'];
                                val.user_name = val['users.user_full_name'];
                                val.created_at = this.$moment(val['out_box_sms_messages.created_at'], 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                                if(val['out_box_sms_groups.send_at'] == '0001-01-01T00:00:00Z'){
                                    val.send_at = '---';
                                } else {
                                    val.send_at = this.$moment(val['out_box_sms_groups.send_at'], 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                                }   
                                val.sms_text = val['out_box_sms_groups.sms_text'];
                                switch(val['out_box_sms_messages.state']){
                                    case 1:
                                        val.state = 'تحویل داده شده';
                                        break;
                                    case 2:
                                        val.state = 'تحویل داده نشده';
                                        break;
                                    case 3:
                                        val.state = 'ارسال شده به مخابرات';
                                        break;
                                    case 0:
                                        if(val['out_box_sms_messages.is_send'] == false){
                                            val.state = 'در صف ارسال';
                                        } else {
                                            val.state = 'ارسال شده و در انتظار تعیین وضعیت';
                                        } 
                                        break;
                                    case -1:
                                        val.state = 'لیست سیاه';
                                        break;
                                    case -2:
                                        val.state = 'تایید نشده';
                                        break;
                                    case -3:
                                        val.state = 'خطا در ارسال';
                                        break;
                                }
                            });
                            this.items = res.data;
                        })
                })
            }
        },
        remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.get();
        },
    },
    beforeCreate() {
        if (this.$store.state.perms.can_view_sms_message_page == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
